// arrastrar el cajón del carrito hacia la derecha para cerrarlo, con inercia
(() => {
  const UMBRAL = 10;
  const reducirMovimiento = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const curva = (nombre) => {
    const valor = getComputedStyle(document.documentElement).getPropertyValue(nombre).trim();
    return valor && CSS.supports('transition-timing-function', valor) ? valor : 'ease-out';
  };

  const activar = (cajon) => {
    let panel;
    let inicio;
    let base;
    let x = 0;
    let historial = [];
    let decidido = false;
    let arrastrando = false;

    cajon.addEventListener('pointerdown', (e) => {
      panel = e.target.closest('.drawer__inner');
      if (!panel || e.pointerType === 'mouse' || !cajon.classList.contains('active')) return;
      if (e.target.closest('a, button, input, select, textarea, summary, label')) return;
      inicio = { x: e.clientX, y: e.clientY };
      historial = [{ t: e.timeStamp, x: e.clientX }];
      decidido = false;
      arrastrando = false;
      x = 0;
    });

    cajon.addEventListener('pointermove', (e) => {
      if (!panel || !inicio) return;
      const dx = e.clientX - inicio.x;
      const dy = e.clientY - inicio.y;

      // hasta que no sabemos si es horizontal o vertical no tocamos nada: el scroll de la lista manda
      if (!decidido) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < UMBRAL) return;
        decidido = true;
        arrastrando = dx > 0 && Math.abs(dx) > Math.abs(dy);
        if (!arrastrando) return;
        base = e.clientX;
        panel.style.transition = 'none';
        cajon.setPointerCapture(e.pointerId);
      }
      if (!arrastrando) return;

      const delta = e.clientX - base;
      // hacia la izquierda resiste; hacia la derecha sigue al dedo
      x = delta >= 0 ? delta : -Math.sqrt(-delta) * 2.2;
      panel.style.transform = `translateX(${x}px)`;
      historial.push({ t: e.timeStamp, x: e.clientX });
      if (historial.length > 6) historial.shift();
    });

    const soltar = () => {
      if (!panel || !arrastrando) {
        inicio = null;
        return;
      }
      const primero = historial[0];
      const ultimo = historial[historial.length - 1];
      const velocidad = ultimo.t > primero.t ? ((ultimo.x - primero.x) / (ultimo.t - primero.t)) * 1000 : 0;
      // proyección de inercia: dónde acabaría el cajón si lo dejáramos deslizar
      const proyectado = x + (velocidad / 1000) * (0.998 / (1 - 0.998));
      const cierra = proyectado > panel.offsetWidth * 0.5;

      const duracion = reducirMovimiento() ? 0 : Math.max(220, 520 - Math.min(Math.abs(velocidad) / 6, 300));
      panel.style.transition = `transform ${duracion}ms ${curva(cierra ? '--muelle-suave' : '--muelle-firme')}`;
      panel.style.transform = '';
      if (cierra) cajon.close();
      panel.addEventListener('transitionend', () => (panel.style.transition = ''), { once: true });

      inicio = null;
      arrastrando = false;
    };
    cajon.addEventListener('pointerup', soltar);
    cajon.addEventListener('pointercancel', soltar);
  };

  customElements.whenDefined('cart-drawer').then(() => document.querySelectorAll('cart-drawer').forEach(activar));
})();
